const GUEST_STATUS_LABELS = {
  PENDING: 'Aktif',
  CANCELLED: 'İptal Edildi',
  EXPIRED: 'Süresi Doldu',
  ENTERED: 'Giriş Yapıldı',
  LOGGEDIN: 'İçeride',
  LOGGEDOUT: 'Dışarıda',
}

const SMS_STATUS_LABELS = {
  FORWARDED: 'İletildi',
  FAILED: 'Başarısız',
  INVALID_NUMBER: 'Geçersiz Numara',
}

const GUEST_TYPE_LABELS = {
  gecici: 'Geçici',
  kalici: 'Kalıcı',
}

const getMappedValue = (map, value) => {
  return map[value] || value
}

const normalizeGuest = (guest) => {
  if (!guest) {
    return guest
  }

  return {
    ...guest,
    guest_name: guest.guest_name || guest.adi_soyadi || '',
    tel: guest.tel || guest.telefon_no || '',
    durum: getMappedValue(GUEST_STATUS_LABELS, guest.durum),
    sms_durum: getMappedValue(SMS_STATUS_LABELS, guest.sms_durum || guest.giris_sms_durum),
    misafir_turu: getMappedValue(GUEST_TYPE_LABELS, guest.misafir_turu),
  }
}

// AGS v3.0 alanları için string -> number cast helper'ları
const toFiniteNumber = (value) => {
  if (value === undefined || value === null || value === '') {
    return null
  }
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : null
}

const toLowerCaseString = (value) => {
  return typeof value === 'string' && value.trim() ? value.trim().toLowerCase() : null
}

const normalizeGarden = (garden) => {
  if (!garden) {
    return null
  }

  const gardenName = garden.bahce_adi || garden.adi || garden.title
  const normalizedGarden = {
    ...garden,
    title: garden.title || gardenName,
    adi: garden.adi || gardenName,
  }

  // AGS v3.0 alanları — API string olarak dönebilir, numeric'e cast et.
  // Backend `barrier_lat: "37.8230000"` string olarak gönderiyor.
  const barrierLat = toFiniteNumber(garden.barrier_lat)
  if (barrierLat !== null) {
    normalizedGarden.barrier_lat = barrierLat
  }
  const barrierLng = toFiniteNumber(garden.barrier_lng)
  if (barrierLng !== null) {
    normalizedGarden.barrier_lng = barrierLng
  }
  const geoThreshold = toFiniteNumber(garden.geo_threshold_m)
  if (geoThreshold !== null) {
    normalizedGarden.geo_threshold_m = geoThreshold
  }
  const bleMajor = toFiniteNumber(garden.ble_major)
  if (bleMajor !== null) {
    normalizedGarden.ble_major = bleMajor
  }
  // v3.1: entry/exit ayri Minor + ayri UUID (Pi tarafi advertise eder).
  const bleEntryMinor = toFiniteNumber(garden.ble_entry_minor)
  if (bleEntryMinor !== null) {
    normalizedGarden.ble_entry_minor = bleEntryMinor
  }
  const bleExitMinor = toFiniteNumber(garden.ble_exit_minor)
  if (bleExitMinor !== null) {
    normalizedGarden.ble_exit_minor = bleExitMinor
  }
  // Geriye uyum: tek minor degeri varsa entry minor olarak kabul et.
  const bleMinor = toFiniteNumber(garden.ble_minor)
  if (bleMinor !== null) {
    if (normalizedGarden.ble_entry_minor === undefined) {
      normalizedGarden.ble_entry_minor = bleMinor
    }
    normalizedGarden.ble_minor = bleMinor
  }

  const bleRssiThreshold = toFiniteNumber(garden.ble_rssi_threshold)
  normalizedGarden.ble_rssi_threshold = bleRssiThreshold !== null ? bleRssiThreshold : -70
  const bleTimeoutMs = toFiniteNumber(garden.ble_timeout_ms)
  if (bleTimeoutMs !== null) {
    normalizedGarden.ble_timeout_ms = bleTimeoutMs
  }
  // BLE UUID karşılaştırma case-insensitive olmalı (ESP-Laravel-RN tutarsızlığı yenir)
  // v3.1: iki ayri UUID (entry/exit). Eski ble_beacon_uuid -> ble_entry_uuid fallback.
  const bleEntryUuid = toLowerCaseString(garden.ble_entry_uuid)
  if (bleEntryUuid) {
    normalizedGarden.ble_entry_uuid = bleEntryUuid
  }
  const bleExitUuid = toLowerCaseString(garden.ble_exit_uuid)
  if (bleExitUuid) {
    normalizedGarden.ble_exit_uuid = bleExitUuid
  }
  const bleBeaconUuid = toLowerCaseString(garden.ble_beacon_uuid)
  if (bleBeaconUuid) {
    normalizedGarden.ble_beacon_uuid = bleBeaconUuid
    if (!normalizedGarden.ble_entry_uuid) {
      normalizedGarden.ble_entry_uuid = bleBeaconUuid
    }
  }

  if (Array.isArray(garden.tanimli_misafirler)) {
    normalizedGarden.tanimli_misafirler = garden.tanimli_misafirler.map(normalizeGuest)
  }

  return normalizedGarden
}

const extractGardenFromApiResponse = (responseData) => {
  return normalizeGarden(responseData?.data || responseData?.item || null)
}

const mergeGardenSelection = (routeGarden, apiGarden) => {
  if (!routeGarden && !apiGarden) {
    return null
  }

  return normalizeGarden({
    ...(routeGarden || {}),
    ...(apiGarden || {}),
  })
}

export { extractGardenFromApiResponse, mergeGardenSelection }
